import React from 'react';
import { NavigationBar } from '../../organisms/shared/navigationBar/NavigationBar';
import { getDataByType } from '../../../utils/utils';
import Footer from '../../organisms/shared/footer/Footer';
import Article from '../../organisms/blogArticle/article/Article';
import { Breadcrumbs } from '../../molecules/shared/breadcrumbs/Breadcrumbs';
import NextArticle from '../../organisms/blogArticle/nextArticle/NextArticle';

export const BlogArticle = ({
  breadcrumbs,
  footer,
  siteUrls,
  menu,
  location,
  locale,
  search,
  sections,
  t,
}) => {
  const data = getDataByType(sections, 'article');
  const nextArticleData = getDataByType(sections, 'nextArticle');
  const helperData = getDataByType(sections, 'helperData');

  return (
    <div>
      <NavigationBar
        scrolledInit
        data={menu}
        location={location}
        locale={locale}
        search={search}
        t={t}
      />
      <main className="mt-32">
        <Breadcrumbs levels={breadcrumbs} />
        <Article data={data.componentData} helperData={helperData} t={t} />
        {nextArticleData && (
          <NextArticle data={nextArticleData.componentData} />
        )}
      </main>
      <Footer data={footer} siteUrls={siteUrls} />
    </div>
  );
};
